import * as yup from 'yup'

const reducedLegalEntityValidationSchema = yup.object().shape({
    rcs: yup
        .string()
        .required('Le numéro RCS est requis')
        .matches(/^\d{9}$/, 'Le RCS doit contenir 9 chiffres'),
    companyName: yup
        .string()
        .required('Le nom de l\'entreprise est requis')
        .min(2, 'Le nom doit faire au moins 2 caractères')
});

export default reducedLegalEntityValidationSchema;